import { FunctionComponent } from 'react'

type GameHelpProps = {
	numWordsRemaining: number
}

const GameHelp: FunctionComponent<GameHelpProps> = props => {
	const { numWordsRemaining } = props

	if (numWordsRemaining <= 7) return null

	// A message will be displayed depending on the number of words remaining to find.
	return (
		<div className="game-help">
			<div className="game-help__message">
				<div>
					{numWordsRemaining === 10 && (
						<p>
							There is <b>one</b> 5-letter word to find in this word search. It may be
							horizontal, vertical or diagonal. It may be in reverse. Swipe it when
							you see it!
						</p>
					)}
					{numWordsRemaining === 9 && (
						<p>Once you have found a word, another word can be found.</p>
					)}
					{numWordsRemaining === 8 && <p>Keep going! There are 10 words to find.</p>}
				</div>
			</div>
		</div>
	)
}

export default GameHelp
